import { render, staticRenderFns } from "./nameCard.vue?vue&type=template&id=72942c4a&scoped=true&"
import script from "./nameCard.vue?vue&type=script&lang=js&"
export * from "./nameCard.vue?vue&type=script&lang=js&"
import style0 from "./nameCard.vue?vue&type=style&index=0&id=72942c4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72942c4a",
  null
  
)

export default component.exports